import Api from './api';

const PrestContasService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/prestcontas/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/prestcontas/buscar?${params}`)
        return response
    },
    cat: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/prestcontas/categorias',
            params: params
        })
        return response
    }
}

export default PrestContasService;